module.exports = __webpack_public_path__ + "img/kakie4_1920x1080-min.12d8bf4c.jpg";